import {css} from "lit-element/lit-element.js";
export default css`.gap-0 {
  gap: 0 !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.column-gap-5 {
  column-gap: 1.25rem !important;
}

.row-gap-5 {
  row-gap: 1.25rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.column-gap-6 {
  column-gap: 1.5rem !important;
}

.row-gap-6 {
  row-gap: 1.5rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.column-gap-7 {
  column-gap: 2rem !important;
}

.row-gap-7 {
  row-gap: 2rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.column-gap-8 {
  column-gap: 2.5rem !important;
}

.row-gap-8 {
  row-gap: 2.5rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.column-gap-9 {
  column-gap: 3rem !important;
}

.row-gap-9 {
  row-gap: 3rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.atlas-checklist {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
